{
  "carrierLabel": "Công ty vận chuyển",
  "searchPlaceholder": "Tìm kiếm theo tên",
  "selectAsCarrier": "Chọn \"{name}\" làm Hãng vận chuyển",
  "typeToSearch": "Nhập để tìm kiếm công ty"
}
